var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimesheet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.263,
    height: 20.683,
    viewBox: "0 0 16.263 20.683",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-timesheet-3681391",
    transform: "translate(-12.7 -2.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2671",
    "data-name": "Group 2671",
    transform: "translate(12.7 2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12446",
    "data-name": "Path 12446",
    d: "M21.409,6.854a4.354,4.354,0,1,0-4.354,4.354A4.353,4.353,0,0,0,21.409,6.854Zm-4.942,0V4.5a.588.588,0,1,1,1.176,0V6.288H18.8a.588.588,0,1,1,0,1.176H17.054A.619.619,0,0,1,16.466,6.854Z",
    transform: "translate(-12.7 -2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12447",
    "data-name": "Path 12447",
    d: "M71.8,24.8v3.266h3.266Z",
    transform: "translate(-58.933 -19.945)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12448",
    "data-name": "Path 12448",
    d: "M37.73,28.772a.585.585,0,0,1-.588-.588V24.2H35.314a5.54,5.54,0,0,1-5.508,5.16A5.024,5.024,0,0,1,29,29.295V39a1.148,1.148,0,0,0,1.154,1.154H40.561A1.162,1.162,0,0,0,41.715,39V28.772H37.73Zm.806,9.144H32.179a.588.588,0,0,1,0-1.176h6.357a.588.588,0,0,1,0,1.176Zm0-2.983H32.179a.588.588,0,1,1,0-1.176h6.357a.588.588,0,1,1,0,1.176Zm0-2.961H32.179a.588.588,0,0,1,0-1.176h6.357a.588.588,0,0,1,0,1.176Z",
    transform: "translate(-25.451 -19.476)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimesheet);
export default __webpack_public_path__ + "static/media/timesheet.ce45981f3beefc94efa20c38be7f76fd.svg";
export { ForwardRef as ReactComponent };